import { useEffect, useRef } from 'react'

import classes from './Transcript.module.css'

import useBotsService from '../../../services/bot/botService';

import Discovery from './discovery/Discovery';

import { useBotConfig } from '../../../context/BotConfigContext';

import CopyBotMessageButton from './CopyBotMessageButton';

import ChatBubble from './ChatBubble/ChatBubble';

import LiveThinkingStream from './LiveThinkingStream/LiveThinkingStream';



function hasBotReplyStarted(entry) {

  return Boolean(entry?.text)

}



function Transcript() {

    const botService = useBotsService()

    const config = useBotConfig()

    const transcript = botService.getCurrentTranscript()

    const isPending = botService.isPendingResponse()

    const showCopy = config?.enableBotMessageCopy === true;

    const bottomOfTheChatRef = useRef()



    useEffect(() => {

        if (bottomOfTheChatRef) {

            bottomOfTheChatRef.current.scrollIntoView({

                behavior: "smooth", block: "nearest",

                inline: "nearest"

            });

        }

    }, [transcript, isPending])



    const renderItems = []



    transcript.forEach((m, i) => {

        if (m.sender === 'USER') {

            renderItems.push({

                type: 'user',

                key: `user-${i}-${m.text}`,

                message: m,

            })

            return

        }



        if (m.sender !== 'MODEL') return



        const isLastModel = i === transcript.length - 1

        const isThinkingPhase = isPending

            && isLastModel

            && m.isStreaming

            && !hasBotReplyStarted(m)



        renderItems.push({

            type: 'model-group',

            key: `model-${i}-${m.userText || m.text || i}`,

            message: m,

            isThinkingPhase,

            thinkingText: m.streamThinking || '',

        })

    })



    const bubbles = renderItems.map((item) => {

        if (item.type === 'user') {

            const m = item.message

            return (

                <div key={item.key} className={classes.UserBubbleContainer}>

                    <div className={classes.UserBubble}>

                        <ChatBubble message={m} urlClickText={config?.urlClickText} />

                    </div>

                </div>

            )

        }



        const m = item.message

        const showModelBubble = Boolean(m.text) || (!item.isThinkingPhase && m.isStreaming)



        return (

            <div key={item.key} className={classes.ModelBubbleContainer}>

                <div className={classes.ModelBubbleWrapper}>

                    {item.isThinkingPhase ? (

                        <LiveThinkingStream

                            text={item.thinkingText}

                            isActive={isPending}

                        />

                    ) : null}

                    {showModelBubble ? (

                        <div className={classes.ModelBubble}>

                            <ChatBubble

                                message={m}

                                urlClickText={config?.urlClickText}

                                isStreaming={m.isStreaming === true}

                            />

                        </div>

                    ) : null}

                    {!item.isThinkingPhase && m.errorMessage ? (

                        <div className={classes.InlineError}>{m.errorMessage}</div>

                    ) : null}

                    {!item.isThinkingPhase && showCopy && m.text ? (

                        <CopyBotMessageButton text={m.text} />

                    ) : null}

                </div>

            </div>

        )

    })



    return (

        <div className={classes.Transcript}>

            <div className={classes.Discovery}>

                <Discovery />

            </div>

            {bubbles}

            <div ref={bottomOfTheChatRef} />

        </div>

    );

}



export default Transcript;


